const advisorTakeGovernanceCriteria = {
    yes: 'Oui',
    no: 'Non',
};

export default advisorTakeGovernanceCriteria;
